export default "__VITE_ASSET__Cp2Lqn5M__"